import { useContext, useEffect, useState } from 'react';
import { BaseConfirmModal, Modal } from '../../../../common/components/modals';
import { EmployeesPortalAPI } from '../../../../services/external/APIs/employees-portal/EmployeesPortal';
import { PendingSchedulingChangeRequestsByUser } from '../../../../models/employees-portal/PendingRequest';
import TabHeader from '../../../../common/components/tab-seccion/TabHeader';
import TabSeccion from '../../../../common/components/tab-seccion/TabSeccion';
import { LoadingTable } from '../../../request-management/components/table';
import { CoveringsAPI } from '../../../../services/external/APIs/coverings/Coverings.api';
import { CoverageRequestsByUserCovering } from '../../../../models/coverings/coverByUser';
import { CoverRequestsByRequestingUser } from '../../../../models/coverings/coverRequestsByUsers';
import { toast } from 'react-toastify';
import { getActionService } from '../../../../utils/getActionService';
import { ACTIONS } from '../../../../constants';
import { AppContext } from '../../../../common';

interface Props {
  isOpen: boolean;
  onClose: (newState: boolean) => void;
}

export const PendingModal = ({ isOpen, onClose }: Props) => {
  const [activeNav, setActiveNav] = useState<number>(1);
  const { langResources, userInfo } = useContext(AppContext);

  const [pendingCoversRequestsByUser, setPendingCoversRequestsByUser] = useState<
    CoverageRequestsByUserCovering[]
  >([]);
  const [coverRequestsByRequestingUser, setCoverRequestsByRequestingUser] = useState<
    CoverRequestsByRequestingUser[]
  >([]);
  const [comments, setComments] = useState('');
  const [status, setStatus] = useState('');
  const [coverId, setCoverId] = useState<number>();
  const [reloadings, setReloadings] = useState<number>(0);
  const [errorMessage, setErrorMessage] = useState('');
  const [isOpenModal, setIsOpenModal] = useState(false);

  const [pendingRequests, setPendingRequests] = useState<PendingSchedulingChangeRequestsByUser>({
    interruptionRequestRequest: [],
    workshiftSchedulingChangeRequest: [],
  });

  const [isLoading, setIsLoading] = useState(false);

  const handlerClose = () => {
    onClose(false);
  };
  const hanlderSubmit = () => {
    onClose(false);
  };

  useEffect(() => {
    setIsLoading(true);
    EmployeesPortalAPI.PendingSchedulingRequest()
      .then((response) => {
        setPendingRequests(response);
      })
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    setIsLoading(true);
    CoveringsAPI.getPendingCoversByUserRequest()
      .then((response) => {
        setCoverRequestsByRequestingUser(response);
      })
      .finally(() => setIsLoading(false));
  }, [reloadings]);

  useEffect(() => {
    setIsLoading(true);
    CoveringsAPI.getPendingCoversByUserCovering()
      .then((response) => {
        setPendingCoversRequestsByUser(response);
      })
      .finally(() => setIsLoading(false));
  }, [reloadings]);

  const handlerAccept = (id: number) => {
    setCoverId(id);
    setComments('');
    setIsOpenModal(true);
    setStatus('aprobar');
  };
  const handlerReject = (id: number) => {
    setCoverId(id);
    setComments('');
    setIsOpenModal(true);
    setStatus('rechazar');
  };

  const onSubmit = () => {
    if (status == 'aprobar' && coverId) {
      let id = toast.loading('Aceptando solicitud de cubrimiento...');

      CoveringsAPI.acceptCoverByUserEmployee(coverId, comments)
        .then((response) => {
          setErrorMessage('');
          toast.update(id, {
            render: 'Se aceptó la solicitud exitosamente',
            type: 'success',
            isLoading: false,
            autoClose: 5000,
            position: toast.POSITION.BOTTOM_RIGHT,
            closeOnClick: true,
            closeButton: true,
          });
          setReloadings(reloadings + 1);
        })
        .catch((error) => {
          let msgError = '';
          if (error.response && typeof error.response.data == 'string') {
            setErrorMessage(error.response.data);
            msgError = error.response.data;
          } else {
            setErrorMessage('Ocurrió un error al aprobar el cubrimiento');
            msgError = 'Ocurrió un error al aprobar el cubrimiento';
          }
          toast.update(id, {
            render: msgError,
            type: 'error',
            isLoading: false,
            autoClose: 5000,
            position: toast.POSITION.BOTTOM_RIGHT,
            closeOnClick: true,
            closeButton: true,
          });
        })
        .finally(() => {
          setIsLoading(false);
          setIsOpenModal(false);
        });
    } else if (status == 'rechazar' && coverId) {
      let id = toast.loading('rechazando solicitud de cubrimiento...');

      CoveringsAPI.noAcceptCoverByUserEmployee(coverId, comments)
        .then((response) => {
          setErrorMessage('');
          toast.update(id, {
            render: 'Se rechazó la solicitud exitosamente',
            type: 'success',
            isLoading: false,
            autoClose: 5000,
            position: toast.POSITION.BOTTOM_RIGHT,
            closeOnClick: true,
            closeButton: true,
          });
          setReloadings(reloadings + 1);
        })
        .catch((error) => {
          let msgError = '';
          if (error.response && typeof error.response.data == 'string') {
            setErrorMessage(error.response.data);
            msgError = error.response.data;
          } else {
            setErrorMessage('Ocurrió un error al rechazar el cubrimiento');
            msgError = 'Ocurrió un error al rechazar el cubrimiento';
          }
          toast.update(id, {
            render: msgError,
            type: 'error',
            isLoading: false,
            autoClose: 5000,
            position: toast.POSITION.BOTTOM_RIGHT,
            closeOnClick: true,
            closeButton: true,
          });
        })
        .finally(() => {
          setIsLoading(false);
          setIsOpenModal(false);
        });
    }
  };
  const hanlderOnClose = () => {
    setCoverId(undefined);
    setStatus('');
    setIsOpenModal(false);
    setErrorMessage('');
  };

  return (
    <>
      <Modal
        isOpen={isOpenModal}
        modalTitle={`Desea ${status} este cubrimiento?`}
        onClose={hanlderOnClose}
        onSubmit={onSubmit}
        widthCustom="600px"
        zindex={9999999}
      >
        <div className="p-3">
          {errorMessage && (
            <div className="alert alert-danger" role="alert">
              {errorMessage.toString()}
            </div>
          )}
          <div className="form-floating">
            <textarea
              className="form-control"
              placeholder="¿Quieres añadir algún comentario?"
              id="floatingTextarea2"
              style={{ height: '100px' }}
              value={comments}
              onChange={(e) => setComments(e.target.value)}
            ></textarea>
            <label htmlFor="floatingTextarea2">¿Quieres añadir algún comentario?</label>
          </div>
        </div>
      </Modal>

      <BaseConfirmModal
        isOpen={isOpen}
        modalTitle={'Solicitudes1 Pendientes'}
        onClose={handlerClose}
        onSubmit={hanlderSubmit}
        disableSubmit={false}
        isShowControls={false}
        isLoading={isLoading}
      >
        <div className=" text-black">
          <div className="card mt-0 p-0">
            <div className="card-header ">
              <ul
                role="tablist"
                id={'profile-tabs'}
                className="nav-tabs-custom rounded card-header-tabs  nav "
              >
                {getActionService(userInfo.actions, ACTIONS['approved.scheduling']) && (
                  <TabHeader
                    currentActiveNav={activeNav}
                    activeNavValue={1}
                    setActiveNav={setActiveNav}
                    text={'Turnos'}
                  />
                )}

                {getActionService(userInfo.actions, ACTIONS['approve.interruptions']) && (
                  <TabHeader
                    currentActiveNav={activeNav}
                    activeNavValue={2}
                    setActiveNav={setActiveNav}
                    text={'Permisos'}
                  />
                )}

                {getActionService(userInfo.actions, ACTIONS['approve.covers']) && (
                  <>
                    <TabHeader
                      currentActiveNav={activeNav}
                      activeNavValue={3}
                      setActiveNav={setActiveNav}
                      text={'Cubrimientos solicitados'}
                    />

                    <TabHeader
                      currentActiveNav={activeNav}
                      activeNavValue={4}
                      setActiveNav={setActiveNav}
                      text={'Cubrimientos por aprobar'}
                    />
                  </>
                )}
              </ul>
            </div>

            <div className="card-body ">
              <div className="tab-content">
                {getActionService(userInfo.actions, ACTIONS['approved.scheduling']) && (
                  <TabSeccion activeNavValue={1} currentActiveNav={activeNav}>
                    <div>
                      {pendingRequests.workshiftSchedulingChangeRequest.length == 0 ? (
                        <p>No hay solicitudes de turnos</p>
                      ) : (
                        pendingRequests.workshiftSchedulingChangeRequest.map((w, i) => (
                          <div className="border rounded-1 vstack gap-2">
                            <div className="border rounded border-dashed p-2">
                              <div className="d-flex flex-column flex-md-row gap-md-0 gap-2 align-items-md-center">
                                <div className="flex-grow-1 overflow-hidden">
                                  <h5 className="fs-13 mb-0 ">
                                    Turno: {w.workshiftName}
                                    <div className="text-muted">
                                      Fecha inicial: {w.startDate.split('T')[0]}
                                    </div>
                                    <div className="text-muted">
                                      Fecha final: {w.endDate.split('T')[0]}
                                    </div>
                                  </h5>
                                </div>

                                <div className="flex-shrink-0 ms-2 d-flex gap-2">
                                  <p>{w.comments}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </TabSeccion>
                )}

                {getActionService(userInfo.actions, ACTIONS['approve.interruptions']) && (
                  <TabSeccion activeNavValue={2} currentActiveNav={activeNav}>
                    <div>
                      {pendingRequests.interruptionRequestRequest.length == 0 ? (
                        <p>No hay solicitudes de permisos</p>
                      ) : (
                        pendingRequests.interruptionRequestRequest.map((w, i) => (
                          <div className="border rounded-1 vstack gap-2">
                            <div className="border rounded border-dashed p-2">
                              <div className="d-flex flex-column flex-md-row gap-md-0 gap-2 align-items-md-center">
                                <div className="flex-grow-1 overflow-hidden">
                                  <h5 className="fs-13 mb-0 ">
                                    Turno: {w.interruptionTypeName}
                                    <div className="text-muted">
                                      Fecha inicial: {w.startDate.split('T')[0]}
                                    </div>
                                    <div className="text-muted">
                                      Fecha final: {w.endDate.split('T')[0]}
                                    </div>
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </TabSeccion>
                )}

                {getActionService(userInfo.actions, ACTIONS['approve.covers']) && (
                  <>
                    <TabSeccion activeNavValue={3} currentActiveNav={activeNav}>
                      <div>
                        {coverRequestsByRequestingUser.length == 0 ? (
                          <p>No hay solicitudes de cubrimientos</p>
                        ) : (
                          coverRequestsByRequestingUser.map((cp) => (
                            <div className="border rounded-1 vstack gap-2 mt-1">
                              <div className="border rounded border-dashed p-2">
                                <div className="d-flex flex-column flex-md-row gap-md-0 gap-2 align-items-md-top">
                                  <div className="flex-grow-1 overflow-hidden">
                                    <h5 className="fs-13 ">
                                      <div>Fecha del cubrimiento: {cp.date.split('T')[0]}</div>

                                      <div className="tex-muted fw-lighter">
                                        Programación a cubrir:{' '}
                                        {cp.requesterCurrentWorkshiftName ?? 'N/A'}
                                      </div>

                                      <div className="text-muted fw-lighter">
                                        Cubridor: {cp.fullNameCoverPerson}
                                      </div>

                                      <div className="text-muted fw-lighter">
                                        Programación actual del cubridor:{' '}
                                        {cp.coverCurrentWorkshiftName}
                                        {cp.coverCurrentInterruptionTypeName}
                                        {!cp.coverCurrentWorkshiftName &&
                                          !cp.coverCurrentInterruptionTypeName &&
                                          'N/A'}
                                      </div>
                                    </h5>
                                  </div>

                                  <div className="flex-shrink-0 d-flex gap-2">
                                    <h5 className="fs-13 mb-0 ">
                                      <div>
                                        {cp.compensationDate &&
                                          'Paga cubrimiento: ' + cp.compensationDate?.split('T')[0]}
                                      </div>
                                      {cp.workshiftToBeCompensatedName && (
                                        <div className="tex-muted fw-lighter">
                                          Turno a compensar: {cp.workshiftToBeCompensatedName}
                                        </div>
                                      )}
                                    </h5>
                                  </div>
                                </div>
                                <hr className="text-muted fw-light mb-1" />
                                <p className="text-muted my-0">Comentarios: {cp.comments}</p>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </TabSeccion>

                    <TabSeccion activeNavValue={4} currentActiveNav={activeNav}>
                      <div>
                        {pendingCoversRequestsByUser.length == 0 ? (
                          <p>No hay solicitudes de cubrimientos pendientes por aprobar</p>
                        ) : (
                          pendingCoversRequestsByUser.map((cp) => (
                            <div className="border rounded-1 vstack gap-2 mt-1">
                              <div className="border rounded border-dashed p-2">
                                <div className="d-flex flex-column flex-md-row gap-md-0 gap-2 align-items-md-top">
                                  <div className="flex-grow-1 overflow-hidden">
                                    <h5 className="fs-13 ">
                                      <div>Fecha del cubrimiento: {cp.date.split('T')[0]}</div>
                                      <div className="tex-muted fw-lighter">
                                        Programación actual: {cp.coverCurrentWorkshiftName}{' '}
                                        {cp.coverCurrentInterruptionTypeName}
                                        {!cp.coverCurrentWorkshiftName &&
                                          !cp.coverCurrentInterruptionTypeName &&
                                          'N/A'}
                                      </div>
                                      <div className="tex-muted fw-lighter">
                                        Programación a cubrir:{' '}
                                        {cp.requesterCurrentWorkshiftName ?? 'N/A'}
                                      </div>
                                    </h5>
                                  </div>

                                  <div className="flex-shrink-0  d-flex gap-2">
                                    <h5 className="fs-13 mb-0 ">
                                      <div className="mb-1">
                                        {cp.compensationDate &&
                                          'Paga cubrimiento: ' + cp.compensationDate?.split('T')[0]}
                                      </div>

                                      <div className="tex-muted fw-lighter">
                                        Solicitante: {cp.fullNameRequestPerson}
                                      </div>

                                      <div className="tex-muted fw-lighter">
                                        {cp.workshiftToBeCompensatedName &&
                                          'Turno a compensar: ' + cp.workshiftToBeCompensatedName}
                                      </div>
                                    </h5>
                                  </div>

                                  <div className="d-flex">
                                    <i
                                      className="ri-checkbox-circle-line h4 text-success "
                                      style={{
                                        cursor: 'pointer',
                                      }}
                                      onClick={() => handlerAccept(cp.id)}
                                    ></i>
                                    <i
                                      className="ri-close-circle-line h4 text-danger "
                                      style={{
                                        cursor: 'pointer',
                                      }}
                                      onClick={() => handlerReject(cp.id)}
                                    ></i>
                                  </div>
                                </div>
                                <hr className="text-muted fw-light mb-1" />
                                <p className="text-muted my-0">Comentarios: {cp.comments}</p>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </TabSeccion>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </BaseConfirmModal>
    </>
  );
};
